<template>
    <div style="height: 50px"></div>

    <v-container fluid>
        <div class="d-flex justify-center align-center fill-height">
            <v-card class="pa-5" width="400">
                <v-card-title class="text-h5">Welcome</v-card-title>
                <v-card-text>
                    If you don't have an account, currently registration is only available in the Discord.
                </v-card-text>
                <v-card-text>
                    <v-form>
                        <v-text-field
                            v-model="username"
                            label="Username"
                            prepend-icon="mdi-account-circle"
                        />
                        <v-text-field
                            :type="showPassword ? 'text' : 'password'"
                            label="Password"
                            v-model="password"
                            prepend-icon="mdi-lock"
                            :append-icon="
                                showPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            @click:append="showPassword = !showPassword"
                            @keyup.enter="login"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex align-center">
                    <span v-if="errorMessage" class="text-body-2 text-red mt-2">{{ errorMessage }}</span>
                    <v-spacer />
                    <v-btn color="info" @click="login">Login</v-btn>
                </v-card-actions>

            </v-card>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'DialogLogin',
    data: () => ({
        showPassword: false,
        username: '',
        password: '',
        errorMessage: '' 
    }),
    emits: ['user-login'],
    methods: {
        login() {
            this.errorMessage = "";

            fetch(`${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    login: this.username,
                    password: this.password,
                }),
            })
                .then((response) => {
                    if (!response.ok)
                        this.errorMessage = "Login failed.";

                    return response.json();
                })
                .then((json) => {

                    localStorage.setItem('Auth', json.auth);
                    localStorage.setItem('PlayerGuid', json.playerGuid);
                    localStorage.setItem('DiscordId', json.discordId);

                    this.$emit('user-login');
                })
                .catch((error) => {
                    console.error('Failed to load items:', error);
                });
            // this.$emit('update:modelValue', false)
        },
    },
};
</script>
